import React, { memo } from "react";
import intl from "../../../../i18n/intl";
import ShopifyModal from "../../../../components/ShopifyModal";

const AutoSourcing = memo(({ open,saveLoading,setSwitchSourcingOpen, handleSourcingConfigOff }) => {
  return (
    <div>
      <ShopifyModal
        id="auto-sourcing-modal"
        open={open}
        onClose={() => setSwitchSourcingOpen(false)}
        heading={intl.get("Auto order sourcing")}
        primaryAction={{
          content: intl.get("Done"),
          loading: saveLoading,
          onAction: () => {
            handleSourcingConfigOff(true)
          },
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () => {
              setSwitchSourcingOpen(false)
            },
          },
        ]}
      >
          <div style={{ padding: "16px" }}>
          {intl.get("Once you activate Auto Order Sourcing, if your store's orders sync with Dropshipman but don't match any products, the system will auto-initiate sourcing requests. Confirm if you want to enable this.")}
          </div>
      </ShopifyModal>
    </div>
  );
});

export default AutoSourcing;
